/**
 * Creates a circular distortion effect (alternate implementation)
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @param {number} time - Animation time
 * @param {number} inside - Inside ring factor (0-1)
 * @param {number} cycleSize - Size of oscillation cycle (0-1)
 * @param {number} scrollOffset - Scroll-based offset for animation
 * @returns {Object} Distorted point {x, y}
 */
export const distortA = (x, y, width, height, time = 1, inside = 0.25, cycleSize = 0.75, scrollOffset = 0) => {
  if (x && y) {
    const pushFactor = 2;

    // Unified scaling reference to keep a circular shape
    const refSize = Math.max(width, height);

    // Calculate offsets to center the circle
    const offsetX = (width - refSize) / 2;
    const offsetY = (height - refSize) / 2;

    // Normalize coordinates using offsets
    const normalx = (x - offsetX) / refSize;
    const normaly = (y - offsetY) / refSize;

    const centerX = 0.5;
    const centerY = 0.5;

    const dx = normalx - centerX;
    const dy = normaly - centerY;
    const dd = Math.sqrt(dx * dx + dy * dy);
    const cycle = Math.sin((time + scrollOffset / 20) * -0.05 * dd) * cycleSize;
    const distDelta = inside + 0.075 * cycle - dd;

    const bentNormalX = (dx / dd) * distDelta;
    const bentNormalY = (dy / dd) * distDelta;

    // Scale back to original dimensions and re-apply offsets
    return {
      x: x + bentNormalX * refSize,
      y: y + bentNormalY * refSize
    };
  } else {
    return { x, y };
  }
};
